module.exports = __webpack_public_path__ + "img/user-inactive.efd33412.svg";